import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { defineComponent, ref, watch } from "vue";
import * as EventTypes from "@/shared/eventTypes";
import { useConversation } from "@/composables/conversation";
import Launcher from "@/components/Launcher.vue";
import Messenger from "@/components/Messenger.vue";
import { useChatConnection } from "@/composables/chatConnection";
import { InitialStateModel } from "@/types/inboundWebhookPayload";
import { useWidgetConfig } from "@/composables/widgetConfig";
import { useWidgetTheme } from "@/composables/widgetTheme";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isReady, isWidgetOpen, setInitialState, closeWidget, openWidget } =
  useConversation();
const { setConfiguration } = useWidgetConfig();
const { theme } = useWidgetTheme();
const { t } = useI18n();

// const toggleColor = () => {
//   fo.setTheme({
//     primaryColor: "#ff0000"
//   })
// }

const initState: InitialStateModel = {
  isWidgetOpen: true,
  conversation: {
    id: "",
    isStarted: true,
    isTransferred: false,
    isEnded: false,
  },
  currentConversationId: "",
  messages: [
    {
      messageId: "1",
      conversationId: "",
      timestamp: new Date().toISOString(),
      connectionId: "",
      visitorId: "",
      data: {
        authorType: "system",
        eventType: "reply",
        author: {
          name: "System",
        },
        text: t("chatWidgetPreview.firstMessage"),
      },
    },
    {
      messageId: "2",
      conversationId: "",
      timestamp: new Date().toISOString(),
      connectionId: "",
      visitorId: "",
      data: {
        authorType: "client",
        eventType: "reply",
        author: {
          name: t("chatWidgetPreview.customerName"),
        },
        text: t("chatWidgetPreview.secondMessage"),
      },
    },
    {
      messageId: "3",
      conversationId: "",
      timestamp: new Date().toISOString(),
      connectionId: "",
      visitorId: "",
      data: {
        authorType: "agent",
        eventType: "reply",
        author: {
          name: t("chatWidgetPreview.agentName"),
        },
        text: t("chatWidgetPreview.thirdMessage"),
      },
    },
  ],
  visitorId: "",
  widgetConfiguration: {
    preChatSurveyFields: [],
    channels: [
      {
        channel: "whatsapp",
        offerTransfer: true,
        offerStartDirect: false,
      },
      {
        channel: "email",
        offerTransfer: true,
        offerStartDirect: false,
      },
    ],
    theme: theme.value,
  },
  visitorInfo: {},
};

setInitialState(initState);
setConfiguration(initState.widgetConfiguration);

const delayedIsWidgetOpen = ref(isWidgetOpen.value);

watch(
  () => isWidgetOpen.value,
  () => {
    // Shim will resize the iframe container depending on open/close state.
    // We will add a slight delay, effectively waiting until the shrinking/growing has completed before transitioning (keeps the transitions looking nice).

    if (isWidgetOpen.value) {
      window.parent.postMessage(
        {
          type: EventTypes.OPEN_WIDGET,
        },
        "*"
      );
      setTimeout(() => {
        delayedIsWidgetOpen.value = true;
      }, 100);
    } else {
      delayedIsWidgetOpen.value = false;
      setTimeout(() => {
        window.parent.postMessage(
          {
            type: EventTypes.CLOSE_WIDGET,
          },
          "*"
        );
      }, 100);
    }
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_unref(isReady))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Messenger, {
          "is-open": delayedIsWidgetOpen.value,
          onMinimize: _unref(closeWidget)
        }, null, 8, ["is-open", "onMinimize"]),
        _createVNode(Launcher, {
          "is-open": delayedIsWidgetOpen.value,
          onOpen: _unref(openWidget),
          onClose: _unref(closeWidget)
        }, null, 8, ["is-open", "onOpen", "onClose"])
      ]))
    : _createCommentVNode("", true)
}
}

})